import { render, staticRenderFns } from "./AboutScreen.vue?vue&type=template&id=12836198"
import script from "./AboutScreen.vue?vue&type=script&lang=js"
export * from "./AboutScreen.vue?vue&type=script&lang=js"
import style0 from "./AboutScreen.vue?vue&type=style&index=0&id=12836198&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports